/* Чистая модель формы слайдов (план вехи 3, mcard-infog K-PM): поддержан ли контракт и какие значения выборов форма получает
   по умолчанию. Одна правда для родной формы (SlideOrderForm.tsx, use-product-defaults.ts) и сервера движка шаблона
   (features/infog/infog-server.ts): заявка одной стороны воспроизводится другой с теми же входами (симметрия отката, I1). */
import type { StudioForm } from '../studio/studio-api';
import { enumOf, fieldOf, initialChoice, textOf, unsupportedFields, type ControlKey } from './product-model';

export type SlideKind = 'post' | 'infog';
/** Контролы экрана: ключи, которые форма может публиковать */
export const SLIDE_CONTROLS: Record<SlideKind, ControlKey[]> = {
  infog: ['text', 'name', 'advantages', 'style', 'platform', 'slides', 'cover', 'specs'],
  post: ['topic', 'style', 'slides', 'format', 'tone'],
};
const ENUMS: ControlKey[] = ['style', 'platform', 'slides', 'cover', 'format', 'tone'];

/** Контракт поддержан: экран тот же, главное поле есть, типы известных полей совпадают, обязательных незнакомых нет. */
export function slideContractSupported(form: StudioForm, kind: SlideKind) {
  if (form.screen !== kind || unsupportedFields(form, SLIDE_CONTROLS[kind]).length) return false;
  const main = kind === 'post' ? textOf(form, 'topic') : (textOf(form, 'text') ?? textOf(form, 'name'));
  if (!main) return false;
  return SLIDE_CONTROLS[kind].every(control => {
    const field = fieldOf(form, control);
    if (!field) return true;
    return ENUMS.includes(control) ? field.type === 'enum' && !field.upload && field.values.length > 0 : field.type === 'text' && !field.upload;
  });
}

/** Пустые опубликованные выборы и их значения по умолчанию: умолчание формы, затем умолчание спецификации (initialChoice).
    Уже выбранное не трогается. → [[ключ поля, значение], …] */
export function productDefaults(
  form: StudioForm | null | undefined,
  inputs: Record<string, string>,
  defaults: ReadonlyArray<readonly [ControlKey, readonly string[]]>,
): Array<readonly [string, string]> {
  if (!form) return [];
  return defaults.flatMap(([control, preferred]) => {
    const field = enumOf(form, control);
    const value = initialChoice(field, [...preferred]);
    return field && value && !inputs[field.key] ? [[field.key, value] as const] : [];
  });
}
